import { render } from "./NavbarMenu.vue?vue&type=template&id=9b04c2f4&scoped=true"
import script from "./NavbarMenu.vue?vue&type=script&lang=js"
export * from "./NavbarMenu.vue?vue&type=script&lang=js"

import "./NavbarMenu.vue?vue&type=style&index=0&id=9b04c2f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b04c2f4"]])

export default __exports__